































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

import Shipment from '@/types/Shipment';
import Shipping from '@/types/Shipping';
import { AxiosError, AxiosResponse } from 'axios';
import OrderAPI from '@/services/OrderAPI';

import utilMixin from '@/mixin/Util';

export default Vue.extend({
    name: 'ShippingSelector',

    props: {
        currentShipment: Object as () => Shipment,
        orderId: String,
        countryCode: String,
        isBoxed: {
            type: Boolean,
            default: true
        }
    },

    mixins: [utilMixin],

    computed: {
        ...mapState(['shippings']),

        ...mapGetters(['numberOrderItems', 'getCurrencySymbol', 'getLanguage'])
    },

    data() {
        return {
            shipment: new Shipment(),
            error: {
                save: ''
                },
            status: '',
            isLoading: false
        };
    },

    created() {
		if (this.currentShipment) {
            this.shipment = JSON.parse(JSON.stringify(this.currentShipment));
        }
    },

    methods: {
        input(): void {
            this.$emit('input', this.isChangesMade());
        },

        filteredShippings(shippings: Shipping[]): Shipping[] {
            return shippings.filter((shipping) =>
                shipping.countryCodes.includes(this.countryCode) &&
                shipping.minItems <= this.numberOrderItems &&
                this.numberOrderItems <= shipping.maxItems);
        },

        setShipping(): void {
            this.error.save = '';
            if (!this.shipment || !this.shipment.shippingId) {
                this.error.save = this.$text('mustSupplyDeliveryMethod');
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    if (response.data) {
                        this.$emit('input', true);
                        this.$store.commit('setOrder', response.data);
                    }
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoading = true;
            OrderAPI
                .createShipping(this.orderId, this.shipment)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        isChangesMade(): boolean {
            return !this.currentShipment && !!this.shipment ||
                this.currentShipment !== undefined && this.shipment !== undefined &&
                this.currentShipment.shippingId !== this.shipment.shippingId;
        }
    }
});
